
    import Vue from "vue";
    import Component from "vue-class-component";
    import { Prop } from "vue-property-decorator";
    import SectionPageHeading from "@/features/shared/components/sections/SectionPageHeading.vue";

    @Component({
        components: {
            SectionPageHeading,
        },
    })
    export default class AdministrationDetailviewLayout extends Vue {
      @Prop({default:"col-xl-8"})
      widthCssClass! : string;
    }
